import { useEffect, useLayoutEffect } from "react";
import { useStores } from "../../store";
import { useLocation } from "react-router-dom";
import { getCurrentUser } from "../../api/authApi";
import { setGlobalNavigate } from "../../api/httpClient";

const PUBLIC_ROUTES = [
  /^\/payment\//,
  /^\/login$/,
  /^\/login\//,
  /^\/$/,
  /^\/signup/,
  /^\/signup_2/,
  /^\/register/,
  /^\/reset-password/,
];

let lastAuthCheck = 0;
const AUTH_CHECK_INTERVAL_MS = 30_000;

export default function AutoLogin() {
  const { UserStore } = useStores();
  const location = useLocation();

  // Runs synchronously before the browser paints — if the auth flag is absent
  // (always cleared on logout), redirect immediately so the protected page is
  // never painted at all. This eliminates the back-button flash.
  // The flag is set in navigateUsingRole on every successful login.
  useLayoutEffect(() => {
    const isPublicRoute = PUBLIC_ROUTES.some((p) => p.test(location.pathname));
    if (isPublicRoute) return;
    if (!sessionStorage.getItem("auth")) {
      window.location.replace("/login");
    }
  }, [location.pathname]);

  // Async session validation — verifies the cookie is still valid with the server.
  useEffect(() => {
    setGlobalNavigate(() => {
      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    });

    const isPublicRoute = PUBLIC_ROUTES.some((p) => p.test(location.pathname));
    if (isPublicRoute) return;
    if (!sessionStorage.getItem("auth")) return;

    const syncCurrentUser = async () => {
      try {
        const meRes = await getCurrentUser();
        if (meRes?.success && meRes?.data) {
          if (UserStore?.setUserDetails) {
            UserStore.setUserDetails(meRes.data);
          }
        } else if (!meRes?.success) {
          window.location.replace("/login");
        }
      } catch (e) {
        // forceLogoutAndRedirect handles 401 inside the interceptor
      }
    };

    const now = Date.now();
    if (now - lastAuthCheck > AUTH_CHECK_INTERVAL_MS) {
      lastAuthCheck = now;
      syncCurrentUser();
    }
  }, [UserStore, location.pathname]);

  return null;
}
